import SliderCarousel from "./SliderCarousel";

export default SliderCarousel;
